import { ADDED_TO_BASKET_MODAL_ID, Locale, Position, PRODUCT_NOTIFY_ME } from '@headless-workspace/config';
import { SideMenuModal } from '@headless-workspace/core-ui';
import { BasketProductValue, VipBrandsValue } from '../../../../../server';
import { ProductAddToBasketModal } from '../../../modals';
import { NotifyMeModal } from '../../../notifyMe/NotifyMeModal';
import { ActionStatus } from '../../delivery/useProductBasketCTABusinessRules';

const createModalOptions = (
    actionStatus: ActionStatus,
    productAddedToBasket: BasketProductValue | undefined,
    vipBrands: VipBrandsValue,
    locale: Locale,
    productIds: string[] | undefined,
): { modalId: string; modal: SideMenuModal } | undefined => {
    const basketModalClasses = 'w-modalAddToCartMobile tablet:w-modalAddToCartTablet m-auto mt-1.25 tablet:mt-1';

    switch (actionStatus) {
        case ActionStatus.AddToBasketCondition:
            return productAddedToBasket
                ? {
                      modalId: ADDED_TO_BASKET_MODAL_ID,
                      modal: SideMenuModal(
                          Position.None,
                          {
                              default: (
                                  <ProductAddToBasketModal
                                      locale={locale}
                                      product={productAddedToBasket}
                                      vipBrands={vipBrands}
                                  />
                              ),
                          },
                          basketModalClasses,
                      ),
                  }
                : undefined;

        case ActionStatus.NotifyMeCondition:
            return productIds
                ? {
                      modalId: PRODUCT_NOTIFY_ME,
                      modal: SideMenuModal(Position.Right, {
                          default: <NotifyMeModal locale={locale} productIds={productIds} />,
                      }),
                  }
                : undefined;

        default:
            return undefined;
    }
};

export const ProductModalHelpers = {
    createModalOptions,
};
